module.exports = __webpack_public_path__ + "static/media/ic-customer-management-active.d75cf9ed.svg";